import { DateTime } from 'luxon';
import { fromJsonArrayWith } from 'src/core/utils';
import { Address, BasicAddress } from '../basic-types/Address';
import SelectedProduct from '../cart/request/SelectedProduct';

/** R57 Q893: a position of a released offer with the offer's own prices; R65: a set lists its components. */
export interface MyOfferLine {
    name: string;
    quantity: number;
    unitNetPrice: number;
    totalNetPrice: number;
    totalGrossPrice: number;
    components: MyOfferLine[];
}

const toLine = (json: any): MyOfferLine => ({
    name: json.localizedName ?? json.invoiceName ?? '',
    quantity: json.quantity ?? 0,
    unitNetPrice: json.nettPrice ?? 0,
    totalNetPrice: json.totalNettPrice ?? 0,
    totalGrossPrice: json.totalGrossPrice ?? 0,
    components: (json.childProducts ?? []).map(toLine),
});

export class MyOffer {
    public readonly id: number;
    public readonly publicId: string;
    public readonly externalOrderId: string;
    public readonly customerId: number;
    public readonly originUserId: number;
    public readonly orderProductList: SelectedProduct[];
    public readonly lines: MyOfferLine[];
    public readonly gross: boolean;
    public readonly totalAmount: number;
    /** R65: the net total — totalAmount stays gross. */
    public readonly totalAmountNet: number;
    /** R65: the monthly leasing rate the offer PDF prints; null when it prints none. */
    public readonly leasingMonthlyRate: number | null;
    public readonly currencyIso: string;
    public readonly mandant: string;
    public readonly paymentMethodIdentifier: string;
    public readonly invoiceState: boolean;
    public readonly billingAddress: Address | BasicAddress;
    public readonly deliveryAddress: Address | BasicAddress;
    public readonly preparedOn: DateTime;
    public readonly validUntil: DateTime;
    public readonly additionalProperties: Record<string, string>;

    constructor(json: any) {
        this.id = json.id;
        this.publicId = json.publicId;
        this.externalOrderId = json.externalOrderId;
        this.customerId = json.customerId;
        this.originUserId = json.originUserId;
        this.orderProductList = fromJsonArrayWith(SelectedProduct.fromJson, json.orderProductList);
        this.lines = (json.orderProductList ?? []).map(toLine);
        this.gross = json.gross;
        this.totalAmount = json.totalAmount;
        this.totalAmountNet = json.totalAmountNet;
        this.leasingMonthlyRate = json.leasingMonthlyRate;
        this.currencyIso = json.currencyIso4217 || json.currencyIso;
        this.mandant = json.mandant;
        this.paymentMethodIdentifier = json.paymentMethodIdentifier;
        this.invoiceState = json.invoiceState;

        this.billingAddress = json.billingAddress.id
            ? new Address(json.billingAddress)
            : new BasicAddress(json.billingAddress);
        this.deliveryAddress = json.deliveryAddress.id
            ? new Address(json.deliveryAddress)
            : new BasicAddress(json.deliveryAddress);

        this.preparedOn = DateTime.fromISO(json.preparedOn);
        this.validUntil = DateTime.fromISO(json.validUntil);
        this.additionalProperties = json.additionalProperties ?? {};
    }
}
